<template>
  <el-dialog title="生成二维码" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <el-form :model="qrCodeForm" label-width="100px">
      <el-form-item label="二维码内容">
        <el-input v-model="qrCodeForm.content" placeholder="请输入二维码内容"></el-input>
      </el-form-item>
      <el-form-item label="二维码大小">
        <el-input-number v-model="qrCodeForm.size" :min="50" :max="300" :step="10"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleGenerate">生成</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'QrCodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    qrCodeForm: {
      type: Object,
      default: () => ({
        content: '',
        size: 150
      })
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  methods: {
    // 生成二维码
    handleGenerate() {
      if (!this.qrCodeForm.content) {
        this.$message.warning('请输入二维码内容');
        return;
      }

      // 发送生成事件
      this.$emit('generate');

      // 关闭弹框
      this.dialogVisible = false;
    },

    // 取消操作
    handleCancel() {
      this.dialogVisible = false;
    },

    // 关闭弹框
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
/* 弹框样式 */
.dialog-footer {
  text-align: center;
}
</style>